import { InjectionToken } from '@angular/core';

export const POPOUT_MODAL_DATA = new InjectionToken<any>('POPOUT_MODAL_DATA');
